import Reveal from "@/components/Reveal";
import { SERVICES, PHONE_1_TEL } from "@/data/site";
import { Check, ArrowUpRight } from "lucide-react";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 bg-slate-50 border-y border-slate-200">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal className="flex flex-wrap items-end justify-between gap-6 mb-16">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-greenDark" data-testid="services-overline">What we do</p>
            <h2 className="mt-4 font-display text-4xl md:text-5xl font-black tracking-tight text-slate-900" data-testid="services-heading">
              B2B Services, <span className="font-serif italic font-semibold text-brand-blue">Delivered</span>
            </h2>
          </div>
          <a href={PHONE_1_TEL} data-testid="services-quote-btn" className="group inline-flex items-center gap-2 text-sm font-bold text-brand-blue">
            Get a wholesale quote
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </Reveal>

        <div className="grid md:grid-cols-12 gap-8">
          <Reveal className="md:col-span-8" data-testid="service-card-housekeeping">
            <ServiceCard service={SERVICES[0]} tall imgClass="h-64" wide />
          </Reveal>
          <Reveal className="md:col-span-4" delay={0.1} data-testid="service-card-stationery">
            <ServiceCard service={SERVICES[1]} tall imgClass="h-64" />
          </Reveal>
          <Reveal className="md:col-span-12" delay={0.15} data-testid="service-card-procurement">
            <div className="group grid md:grid-cols-2 overflow-hidden rounded-[2rem] border border-slate-200 bg-white transition-shadow duration-300 hover:shadow-[0_30px_60px_-30px_rgba(18,58,102,0.3)]">
              <div className="p-10 md:p-14 flex flex-col justify-center">
                <CardBody service={SERVICES[2]} />
              </div>
              <div className="relative overflow-hidden min-h-[280px]">
                <img src={SERVICES[2].img} alt={SERVICES[2].title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ service, tall, imgClass, wide }) {
  return (
    <div className="group flex flex-col h-full overflow-hidden rounded-[2rem] border border-slate-200 bg-white transition-shadow duration-300 hover:shadow-[0_30px_60px_-30px_rgba(18,58,102,0.3)]">
      <div className={`relative overflow-hidden ${imgClass}`}>
        <img src={service.img} alt={service.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-blueDeep/50 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
      </div>
      <div className={`p-8 md:p-10 flex-1 flex flex-col ${wide ? "" : ""}`}>
        <CardBody service={service} />
      </div>
    </div>
  );
}

function CardBody({ service }) {
  return (
    <>
      <h3 className="font-display text-2xl md:text-3xl font-extrabold tracking-tight text-slate-900">{service.title}</h3>
      <p className="mt-4 text-base leading-relaxed text-slate-600">{service.desc}</p>
      <ul className="mt-6 space-y-2.5">
        {service.points.map((p) => (
          <li key={p} className="flex items-center gap-2.5 text-sm font-medium text-slate-700">
            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-brand-green/15 text-brand-greenDark">
              <Check size={12} strokeWidth={3} />
            </span>
            {p}
          </li>
        ))}
      </ul>
    </>
  );
}
